// extracted by mini-css-extract-plugin
export var container = "_5w-0";
export var containerTopRight = "_5w-1";